const getCompoundEntityTitle = require("./getCompoundEntityTitle");
const getDateTimeFromValue = require("./getDateTimeFromValue");

function extractRelData(key, relationships) {
	let data;
	if (typeof relationships[key] !== "undefined") {
		if (!!relationships[key].data) {
			return Array.isArray(relationships[key].data)
				? relationships[key].data
				: [relationships[key].data];
		}
	}
	return data;
}

function extractDisplayData({
	key,
	attributes,
	relationships,
	bundles,
	private = false,
	configs = null,
}) {
	let value;
	let is_date = key.includes("date");
	if (typeof attributes[key] !== "undefined" && attributes[key]) {
		if (
			typeof attributes[key] === "object" &&
			!Array.isArray(attributes[key]) &&
			attributes[key] !== null
		) {
			if (attributes[key].uri) {
				value = `<a href="${attributes[key].uri}" target="_blank">${
					attributes[key].title ? attributes[key].title : "Learn more"
				}</a>`;
			}
		} else {
			if (is_date) {
				let date_obj = getDateTimeFromValue(attributes[key]);
				value = date_obj.toFormat("LL/dd/yyyy");
			} else {
				value = attributes[key];
			}
		}
	} else if (typeof relationships[key] !== "undefined" && !!relationships[key].data) {
		let bundle_name =
			process.env.CLF_HAS_SEARCH && bundles
				? bundles.find((b) => b === key.replace("field_", ""))
				: null;
		let rels = Array.isArray(relationships[key].data)
			? relationships[key].data
			: [relationships[key].data];
		let vals = rels
			.filter((r) => !!r.attributes)
			.map((r) => {
				const config = configs[r.type];
				let label =
					config && config.titleSchema
						? getCompoundEntityTitle(config.titleSchema, r.attributes)
						: r.attributes.name
						? r.attributes.name
						: r.attributes.title;
				let slug = r.attributes.slug
					? r.attributes.slug
					: bundle_name
					? `${
							private ? process.env.CLF_PRIVATE_ROUTE : ""
					  }/search?filter=field_${bundle_name}&field_${bundle_name}=${encodeURIComponent(
							label
					  )}`
					: null;
				if (slug) {
					return `<a href="${slug}">${label}</a>`;
				} else {
					return label;
				}
			});
		if (vals.length > 0) {
			value = vals.join(", ");
		}
	}
	return value;
}

module.exports = function transformFieldsDisplayData({
	entity,
	singleAttributes,
	singleRelationships,
	fieldList = null,
	bundles,
	configs,
}) {
	const { attributes, id, type } = entity;
	let data = {
		id,
		type,
		title: attributes.title,
		fields: [],
		style: attributes.field_card_style,
		showTitle: attributes.field_display_title,
	};

	let field_list = fieldList
		? fieldList
		: attributes.field_fields_list
		? attributes.field_fields_list.split("\r\n")
		: null;

	if (field_list.length > 0) {
		data.fields = field_list.map((f) => {
			let [label, key] = f.includes("[") ? f.split("[")[0].split("|") : f.split("|");
			let value;
			if (f.includes("[")) {
				let sub_fields = f.split("[")[1].replace("]", "").split(",");
				let rel = extractRelData(key, singleRelationships);
				if (rel) {
					value = [];
					rel.forEach((r) => {
						let sub_value = sub_fields.map((sf) => {
							let [sf_label, sf_key] = sf.split("|");
							return {
								label: sf_label,
								value: extractDisplayData({
									key: sf_key,
									attributes: r.attributes,
									relationships: r.relationships,
									configs,
								}),
							};
						});
						// filter undefined values
						sub_value = sub_value.filter((sv) => !!sv.value);
						value.push(sub_value);
					});
				}
			} else {
				value = extractDisplayData({
					key,
					attributes: singleAttributes,
					relationships: singleRelationships,
					bundles,
					configs,
				});
			}

			let field_data = {
				label,
				value,
			};
			return field_data;
		});
	}
	return data;
};
